import { END_POINT } from "../constants";
import { HTTP } from "./http";

export const StickersService = {

    save: (form: FormData) => {
        return HTTP.post<any, any>(`${END_POINT}stickers`, form);
    },
    getAll: () => {
        return HTTP.get<any, any>(`${END_POINT}stickers`);
    },
    delete: (id: string) => {
        return HTTP.delete<any, any>(`${END_POINT}stickers/${id}`);
    }
}